module.exports = __webpack_public_path__ + "img/set_alpha_3.260b4331.png";